module.exports = __webpack_public_path__ + "img/qrcode_act_816.89d457dc.jpeg";